import React from "react";
import {
  Typography,
  IconButton,
  styled,
  List,
  ListItem,
  Box,
  InputAdornment,
  Button,
} from "@mui/material";
import { Stack } from "@mui/system";
import { TextField } from "../inputs";

export interface FooterInterface {
  onFbClick: () => void;
  onMailClick: () => void;
  onTwitterClick: () => void;
  onLinkenInClick: () => void;
  handleSubmit: () => void;
  options: { label: string; value: string }[];
  onSelectOption: (value: string) => void;
  onClick?: () => void;
}

const CenterStack = styled(Stack)(() => ({
  borderRight: "1px solid rgba(177, 210, 56, 0.25)",
  borderLeft: "1px solid rgba(177, 210, 56, 0.25)",
}));

const CustomList = styled(List)(() => ({
  width: "fit-content",
  "& .MuiListItem-root": {
    cursor: "pointer",
  },
}));

const StyledTextField = styled(TextField)(() => ({
  "& .MuiInputBase-root": {
    height: "100%",
    paddingRight: 0,
    border: "1px solid white"
  },
  "& .MuiInputAdornment-root": {
    height: "100%",
    maxHeight: "100%",
    background: "transparent",
    "& .MuiButtonBase-root": {
      height: "100%"
    }
  }
}));


const Footer = ({
  onFbClick,
  onMailClick,
  onTwitterClick,
  onLinkenInClick,
  handleSubmit,
  options,
  onClick,
  onSelectOption,
}: FooterInterface) => {
  return (
    <Stack className="background-black" pt={6} pb={3}>
      <Stack px="10%" spacing={8}>
        <Box onClick={onClick} style={{ cursor: "pointer" }}>
          <img src="/assets/logo.png" width={260} height={55} alt="logo" />
        </Box>
        <Stack flexDirection="row">
          <Stack width="40%" spacing={5} pr={6}>
            <Stack spacing={1.3}>
              <Typography
                variant="h4"
                fontWeight={400}
                className="font-primary"
              >
                I HAVE FOMO
                <br />
                (Fear Of Missing Out)
              </Typography>
              <Typography variant="h4" fontWeight={400} className="font-white">
                So please add me to your VIP list!
              </Typography>
            </Stack>
            <StyledTextField
              placeholder="Email Address"
              InputProps={{
                className: "font-white",
                endAdornment: (
                  <InputAdornment position="end">
                    <Button
                      variant="contained"
                      onClick={handleSubmit}
                    >
                      Submit
                    </Button>
                  </InputAdornment>
                )
              }}
            />
            <Stack direction="row" spacing={2}>
              <IconButton onClick={onFbClick}>
                <i className="fab fa-facebook font-white" />
              </IconButton>
              <IconButton onClick={onMailClick}>
                <i className="far fa-envelope font-white" />
              </IconButton>
              <IconButton onClick={onTwitterClick}>
                <i className="fab fa-twitter font-white" />
              </IconButton>
              <IconButton onClick={onLinkenInClick}>
                <i className="fab fa-linkedin font-white" />
              </IconButton>
            </Stack>
          </Stack>
          <CenterStack width="38%" alignItems="center" spacing={2}>
            <CustomList>
              {options.map((option) => (
                <ListItem
                  disablePadding
                  onClick={() => onSelectOption(option.value)}
                  style={{ marginBottom: 25 }}
                >
                  <Typography
                    variant="h4"
                    fontWeight={400}
                    className="font-white"
                  >
                    {option.label}
                  </Typography>
                </ListItem>
              ))}
            </CustomList>
          </CenterStack>
          <Stack width="24%" pl={12} spacing={3}>
            <Typography variant="h4" className="font-white">
              Contact Us
            </Typography>
            <Stack direction="row" spacing={1.5}>
              <i
                className="fas fa-map-marker-alt font-white"
                style={{ marginTop: 6 }}
              />
              <Typography
                variant="h4"
                fontWeight={400}
                className="font-white"
              >
                EventView360
                <br />
                8924 E. Pinnacle Peak Rd. STE G-5 #619 Scottsdale, AZ 85255-3649
              </Typography>
            </Stack>
            <Stack direction="row" spacing={1.5}>
              <i className="fas fa-phone-alt font-white" />
              <Typography variant="h4" fontWeight={400} className="font-white">
                Phone: (949) 302-6472
              </Typography>
            </Stack>
            <Stack direction="row" spacing={1.5}>
              <i className="fas fa-envelope font-white" />
              <Typography variant="h4" fontWeight={400} className="font-white">
                info@eventview360.com
              </Typography>
            </Stack>
          </Stack>
        </Stack>
        <Stack alignItems="center">
          <Typography
            className="font-white"
            variant="h5"
            fontWeight={400}
            style={{ opacity: "53%" }}
          >
            Copyright &copy; 2017-2021 All Rights Reserved
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};
export default Footer;
